import { createRoute } from "@tanstack/react-router";
import { CreatedDevelopmentMonthlyTable } from "@/components/teams/created-development-monthly-table";
import { TeamRosterPage } from "@/components/teams/team-roster-page";
import { Route as authenticatedRoute } from "../_authenticated";

const members = [
  {
    name: "Alex Sohn",
    title: "Created Director",
    ownerId: "43404667-980f-4ec1-8900-0abfbfafd629",
    image: "/assets/headshots/alex-sohn.png",
  },
  {
    name: "Hope Damron",
    title: "Created Manager",
    ownerId: "f038fae9-5c46-4cc1-a5ea-9788166788ff",
    image: "/assets/headshots/hope-damron.png",
  },
  {
    name: "Alyssa Albornaz",
    title: "PopUp Specialist",
    ownerId: "8cf396e3-2784-42dc-849f-2ce797eca145",
    image: "/assets/headshots/alyssa-albornoz.png",
  },
];

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/teams/created/development",
  component: () => (
    <TeamRosterPage team="Created Team – Development" members={members}>
      <CreatedDevelopmentMonthlyTable />
    </TeamRosterPage>
  ),
});
